import dynamic from 'next/dynamic';
import Store from '~/store/undux';
import SiteSettings from '~/siteSettings';
import { getVideoKeywords, mobileCheck } from '~/utils/utils';
import { useRouter } from 'next/router';
import uuidv1 from 'uuid/v1';

const CmvAvia = dynamic(() => import('@cbsi-ctd/cmv_avia').then((mod) => mod.Player), { ssr: false });

/**
 * VideoPlayerWithStore
 * @category Functional Component
 * @extends Component
 * @summary Display the social links.
 * @prop {object} content - The page content.
 * @prop {object} drupalSettings - The drupal settings.
 * @prop {object} playlist - The playlist.
 * @return {Node} React node containing video player with store.
 */

const VideoPlayerWithStore = props => {
  const { content, drupalSettings, playlist, store, pageType, parentNid, section } = props;
  const setPlaylistIndex = store.set('playlistIndex');
  const getPlaylistIndex = () => {
    return store.get('playlistIndex');
  }

  let continuousPlay = 0;
  const onContentComplete = () => {
    continuousPlay = 1;
    setPlaylistIndex(getPlaylistIndex() + 1);
  }

  const router = useRouter();

  const metadata = {
    assetId: content.nid,
    assetPubDate: content?.field_display_date || null,
    assetTitle: content.title,
    assetType: 'content_video',
    authorName: 'The Drew Barrymore Show Staff',
    brandPlatformId: mobileCheck() ? 'drewbarrymore_site_mweb' : 'drewbarrymore_site_desktop',
    category: content.field_video?.field_category?.name || 'qos',
    contentBrand: SiteSettings.siteName,
    deviceType: mobileCheck() ? 'mobile' : 'desktop',
    duration: content.field_video.field_video_mpx_id.duration,
    gaAccount: 'UA-1072526-1',
    mediaContentType: 'vod',
    mediaAutoPlayCustom: true,
    mediaId: content?.field_video?.field_video_mpx_id?.mpx_id || content?.field_video?.field_video_mpx_id?.reference_id,
    mii: {
      viewtime: '10',
      refreshcap: '1000',
    },
    pageName: `${SiteSettings.brand}:${router.asPath}`,
    pageURL: router.asPath,
    pageType: pageType,
    pageViewGuid: uuidv1(),
    parentNid: parentNid,
    section: section,
    siteCode: SiteSettings.brand,
    siteHier: `${section}|${pageType}`,
    sitePrimaryRsid: 'cbsidrewbarrymoresite',
    siteSection: section,
    siteType: 'responsive_web',
    thumbnail: `${ content?.field_video_mpx_id?.thumbnails?.[0].streamingUrl || content?.field_video?.field_video_mpx_id?.thumbnails?.[0].streamingUrl }?width=720&crop=16:9`,
    userState: 'not authenticated',
    userType: 'anon',
    videoAutoPlay: 'on',
    videoExists: 'true',
    videoId: content?.field_video_reference_id || content.reference_id || content?.field_video?.field_video_mpx_id?.reference_id,
    videoReferenceId: content?.field_video_reference_id || content.reference_id || content?.field_video?.field_video_mpx_id?.reference_id,
    videoTitle: content?.title,
    vidPlayerPos: 'hero',
    vidPlaylistPos: getPlaylistIndex() || '0',
  }

  return(
    <CmvAvia
      autoplay='attemptUnmutedThenMuted'
      captions={ content?.field_video_captions?.path }
      compactViewBreakpoint={480}
      continuousPlay={continuousPlay}
      enableOm
      fms={ drupalSettings?.videoSettingsQuery?.enable_fms }
      hideAds={ content.field_video.field_is_promotional }
      keywords={ getVideoKeywords(content) }
      metadata={metadata}
      onContentComplete={onContentComplete}
      playlistArr={playlist}
      playlistIndex={getPlaylistIndex()}
      posterImageUrl={`${ content?.field_video?.field_video_mpx_id?.thumbnails?.[0].streamingUrl }?width=720&crop=16:9`}
      siteSettings={SiteSettings}
      useUnmuteCta={true}
    />
  );
}

export default Store.withStore(VideoPlayerWithStore);

